<div class="table-responsive" [class.overflow-hidden]="settingsEmailMergeService.emptyRowService.emptyRow.length > 0">
    <table class="table table-striped table-hover footable">
        <thead>
            <tr [ngClass]="{'noSort': settingsEmailMergeService.data.corporations.data.length < 2}">
                <th></th>
                <th>Property Group Name</th>
                <th>Building Names</th>
                <th>Addresses</th>
            </tr>
        </thead>
        <tbody>
            <ng-template ngFor let-item [ngForOf]="settingsEmailMergeService.data.corporations.data" let-index="index">
                <tr [ngClass]="{'footable-odd': (index % 2 === 0)}" (click)="toggleCheck(item)">
                    <td>
                        <label class="img-checkbox">
                            <input type="checkbox" [ngModel]="item.checked">
                            <label><svg-checked></svg-checked></label>
                        </label>
                    </td>
                    <td>{{item.name}}</td>
                    <td class="table-hint-td">
                        <div class="table-hint {{index > 7 ? 'up' : 'down'}}">
                            <div *ngFor="let b of item.buildings; let last = last;">{{b.name}}{{!last ? ', ' : ''}}</div>
                        </div>
                        <div class="clickable-text mtv-primary-color" (click)="showHint($event)">
                            <span *ngFor="let b of item.buildings; let last = last;">{{b.name}}{{!last ? ', ' : ''}}</span>
                        </div>
                    </td>
                    <td class="table-hint-td">
                        <div class="table-hint {{index > 7 ? 'up' : 'down'}}">
                            <div *ngFor="let b of item.buildings; let last = last;">{{b.address}}{{!last ? ', ' : ''}}</div>
                        </div>
                        <div class="clickable-text mtv-primary-color" (click)="showHint($event)">
                            <span *ngFor="let b of item.buildings; let last = last;">{{b.address}}{{!last ? ', ' : ''}}</span>
                        </div>
                    </td>
                </tr>
            </ng-template>
            <tr *ngFor="let item of settingsEmailMergeService.emptyRowService.emptyRow" style="cursor: default;">
                <td></td>
                <td></td>
                <td></td>
                <td></td>
            </tr>
        </tbody>
    </table>
    <h2 *ngIf="settingsEmailMergeService.data.corporations.data.length === 0 && !settingsEmailMergeService.spinnerShow && !settingsEmailMergeService.showServiceUnavailable"
        class="text-center">
        Result Not Found
    </h2>
    <h2 *ngIf="settingsEmailMergeService.showServiceUnavailable" class="text-center">Service Unavailable</h2>
</div>



// WEBPACK FOOTER //
// /app/src/app/views/settings-email-merge/corporations-list/corporations-list.component.html